export const klok = require('./Klok.mp3');
export const douche = require('./Douche.mp3');
export const wasmachine = require('./Wasmachine.mp3');
export const computer_ventilator = require('./Computer_ventilator.mp3');
export const licht_ruis = require('./Licht_ruis.mp3');
export const afzuigkap = require('./Afzuigkap.mp3');
export const airco = require('./Airco.mp3');
export const fornuis = require('./Fornuis.mp3');
export const friezer =require('./Friezer.mp3');